import ArrowLineDown from 'assets/Icons/Arrow/ArrowLineDown';
import { HeaderWrapper, Layout, TableCell, TableLayout } from 'components/Hospital/PaginationForms';
import { viewDetailPatientListHeader, viewDetailPatientListWidth } from 'constants/pagination';
import { ViewDetailPatientPaginationProps } from 'models/Hospital/paginationTypes';
import ViewDetailPatientPaginationTable from './ViewDetailPatientPaginationTable';
import { NothingDataPatientDiagnosis } from '../../Admin/DCK/AddDiagnosisPage/NothingDataInPagination';
import { OtherSortingButton } from 'styles/Global/buttonStyles';
import ArrowLineUp from 'assets/Icons/Arrow/ArrowLineUp';
import CustomedPagination from 'components/Pagination/CustomedPagination';

const ViewDetailPatientPagination = ({ handleSorting, sortDirections, currentPage, totalPages, pageGroup, handlePageGroup, handlePageChange, currentData }: ViewDetailPatientPaginationProps) => {
    return (
        <Layout>
            <TableLayout>
                <HeaderWrapper>
                    {viewDetailPatientListHeader.map((name, idx) => {
                        return (
                            <TableCell
                                key={idx}
                                $idx={idx}
                                $width={viewDetailPatientListWidth[idx]}
                                $type='header'
                                $justifyContent='space-between'
                                // hover={setSelectHeader}
                                cellType={name.type}
                            >
                                {name.title}
                                {name.title === 'No.' && <OtherSortingButton onClick={handleSorting}>{sortDirections ? <ArrowLineUp /> : <ArrowLineDown />}</OtherSortingButton>}
                            </TableCell>
                        );
                    })}
                </HeaderWrapper>
                {!currentData || currentData?.length === 0 ? <NothingDataPatientDiagnosis /> : <ViewDetailPatientPaginationTable currentData={currentData} />}
            </TableLayout>
            {currentData && totalPages !== 0 && (
                <CustomedPagination currentPage={currentPage} onChangeCurrentPage={handlePageChange} onChangeSectionIdx={handlePageGroup} sectionIndex={pageGroup} totalPages={totalPages} />
            )}
        </Layout>
    );
};

export default ViewDetailPatientPagination;
